import { Body, UnorderedList, ListItem, Link } from '@hover/blueprint';
import React from 'react';
import { ITermsOfUseContent } from '../interfaces/ITermsOfUseContent';

export const TERMS_OF_USE_CONTENT: ITermsOfUseContent[] = [
  {
    title: 'Certain definitions',
    id: 'term-certain-definitions',
    renderContent() {
      return (
        <>
          <Body mb={500}>
            <b>&quot;Blueprint Source&quot;</b> means technical drawings,
            architectural plans, or other representative architectural work of a
            structure submitted to HOVER through the HOVER Web App, the HOVER
            App, or other means;
          </Body>
          <Body mb={500}>
            <b> &quot;Co-Branded App&quot;</b> means the HOVER App, HOVER Web
            App, HOVER Report, or HOVER Deliverables that is co-branded for
            Sponsor in accordance with the Order Documentation;
            &quot;Customer&quot; means a User or Sponsor, as applicable, that
            downloads or uses the HOVER Software and Services.
          </Body>
          <Body mb={500}>
            <b> &quot;Data Privacy Laws&quot;</b> means any applicable privacy
            statute or regulation governing the collection and processing of
            personal information or personal data, such as California Consumer
            Protection Act, GDPR, UK Data Protection Act, or Switzerland Federal
            Act on Data Protection, each as amended;
          </Body>
          <Body mb={500}>
            <b>&quot;Derived Data&quot;</b> means floorplans, the Property
            Information, Scene Data, and Structure Measurements, collected
            through the Software and Services or derived through the HOVER
            Production Process to create a HOVER Model, including a HOVER
            Report, to the extent anonymized;
          </Body>
          <Body mb={500}>
            <b>&quot;Estimation Platform&quot;</b> means the functionality
            within the HOVER App used to generate an Estimate Deliverable,
            excluding Sponsor information used to populate an Estimate
            Deliverable;
          </Body>
          <Body mb={500}>
            <b>&quot;Estimate Deliverable&quot;</b>means forms and templates for
            generating a quote or ordering materials for a single Subject
            Property, including the quote, materials order, bill of materials,
            takeoff, or other output of the Estimation Platform;
          </Body>
          <Body mb={500}>
            <b>&quot;European Resident&quot;</b>means a resident who lives in
            one of the European Union, United Kingdom, or Switzerland;
          </Body>
          <Body mb={500}>
            <b>&quot;GDPR&quot;</b> means Regulation (EU) 2016/679 of the
            European Parliament and of the Council of 27 April 2016 on the
            protection of natural persons with regard to the processing of
            personal data and on the free movement of such data, and repealing
            Directive 95/46/EC (General Data Protection Regulation);
          </Body>
          <Body mb={500}>
            <b>&quot;HOVER&quot;</b> means Hover Inc., a Delaware corporation;
          </Body>
          <Body mb={500}>
            <b>&quot;HOVER App&quot;</b> means a version of the HOVER mobile
            application (and any companion applications to web-based tools
            through the HOVER Website) used to collect Image Data, view HOVER
            Models and order HOVER Models, and also includes all Co-branded
            Apps;
          </Body>
          <Body mb={500}>
            <b>&quot;HOVER Deliverables&quot;</b> means HOVER Models, HOVER New
            Construction Models, Estimate Deliverables, HOVER Renderings, and
            any other products and services related thereto which are ordered by
            Sponsor or otherwise made available to Sponsor and Users (for
            clarity, HOVER Deliverables includes future products and services);
          </Body>
          <Body mb={500}>
            <b> &quot;HOVER Rendering&quot;</b> means one or more perspective
            views of a HOVER Model or other input subject to additional image
            processing;
          </Body>
          <Body mb={500}>
            <b>&quot;HOVER Model&quot;</b> means a digital version of HOVER’s 2D
            or 3D HOVER reconstruction of all or part of the exterior or
            interior of a Subject Property, of a type identified in the HOVER
            App or the HOVER Website (e.g., Roof Only or Complete, Expedited,
            TLA Premium, etc.) and generated through the HOVER Production
            Process, and which contains the Derived Data;
          </Body>
          <Body mb={500}>
            <b>&quot;HOVER New Construction Model&quot;</b> means a digital
            version of a 3D reconstruction of a single structure depicted in a
            Blueprint Source generated through the HOVER Production Process, and
            contains Derived Data;
          </Body>
          <Body mb={500}>
            <b> &quot;HOVER Production Process&quot;</b> means the production
            processes used by HOVER to create a HOVER Deliverable;
          </Body>
          <Body mb={500}>
            <b>&quot;HOVER Report&quot;</b> means a report that contains a
            description or representation of a HOVER Model or a HOVER New
            Construction Model and contains the applicable Derived Data;
          </Body>
          <Body mb={500}>
            <b>&quot;HOVER Web App&quot;</b> means the web application used to
            order, view, and manage HOVER Deliverables;
          </Body>
          <Body mb={500}>
            <b>&quot;HOVER Website&quot;</b> means web-based tools and content
            available for access through&nbsp;
            <Link href="https://www.hover.to">www.hover.to</Link>;
          </Body>
          <Body mb={500}>
            <b>&quot;Image Data&quot;</b> means the photos, video, images and
            other data (such as a Blueprint Source), including without
            limitation, the geospatial or other metadata embedded in therein
            that is submitted or otherwise provided to HOVER;
          </Body>
          <Body mb={500}>
            <b>&quot;Inspection Checklist&quot;</b> means a customizable digital
            questionnaire form enabling a User to record information about a
            Subject Property;
          </Body>
          <Body mb={500}>
            <b> &quot;Order Documentation&quot;</b> means any agreement, order
            form, pricing addendum, or online order submission interface or
            document used to purchase HOVER Deliverables and any subsequent
            amendment or addendum thereto entered into;
          </Body>
          <Body mb={500}>
            <b>&quot;Property Information&quot;</b>means the address and
            location of the Subject Property, which may be derived from the
            Image Data or from other geolocation information;
          </Body>
          <Body mb={500}>
            <b>&quot;Scene Data&quot;</b> means non-geometrical data within
            Image Data;
          </Body>
          <Body mb={500}>
            <b>&quot;Service Provider&quot;</b> means a third-party who
            downloads or uses the HOVER App to obtain a HOVER Deliverable with
            respect to a Subject Property;
          </Body>
          <Body mb={500}>
            <b> &quot;Software and Services&quot;</b> means collectively, the
            HOVER App, the HOVER Web App, HOVER Production Process, the
            Estimation Platform, application programming interfaces provided by
            HOVER, and the HOVER Deliverables used by a User or applicable
            Sponsor, as amended and supplemented from time to time;
          </Body>
          <Body mb={500}>
            <b>&quot;Sponsor&quot;</b> means a HOVER licensee that has
            contracted with HOVER to provide the Software and Services;
          </Body>
          <Body mb={500}>
            <b>&quot;Structure Measurements&quot;</b> means the exterior or
            interior lines and measurements associated with a Subject Property
            or respective HOVER Model;
          </Body>
          <Body mb={500}>
            <b>&quot;Subject Property&quot;</b> means the interior and exterior
            structures, location, rooms, or premises being photographed by a
            User using the HOVER App and in respect of which a HOVER Model is
            produced;
          </Body>
          <Body mb={500}>
            <b>&quot;Sponsored User&quot;</b> means a Sponsor’s employees,
            affiliates, Service Providers, or other Users authorized by the
            Sponsor to use the HOVER App to order or receive HOVER Deliverables;
          </Body>
          <Body mb={500}>
            <b>&quot;User&quot;</b> means an individual who downloads or uses
            the HOVER App, including a customer of a Sponsor who downloads and
            uses the HOVER App to transact with the Sponsor, a Sponsored User,
            or a Service Provider, as applicable.
          </Body>
        </>
      );
    },
  },
  {
    title: 'Requirements of the HOVER App',
    id: 'term-requirements-hover-app',
    renderContent() {
      return (
        <>
          <Body mb={500}>
            The HOVER App is compatible only with those smartphones and
            operating systems identified by HOVER. The use of the HOVER App
            requires and utilizes internet connectivity and data. Carrier and
            provider rates for data may apply, and Users are responsible for any
            such charges. Use of the HOVER App could result in significant data
            usage.
          </Body>
          <Body mb={500}>
            The Software and Services and production of HOVER Deliverables are
            dependent on the accuracy of the data submitted, including
            geopositional data of the devices used and the quality of the Image
            Data submitted. Quality may refer to the format, number, location,
            clarity, and sequence and other data and information required or
            requested by the HOVER Production Process or the HOVER App. Customer
            acknowledges that failure to properly provide such images, data and
            information may limit or prevent the functionality of the HOVER App,
            the HOVER Production Process, and creation of a HOVER Deliverable.
          </Body>
          <Body mb={500}>
            HOVER has no liability for errors, unreliable operation, or other
            issues resulting from use of the HOVER App or HOVER Deliverables on
            or in connection with rooted or jailbroken devices or use on any
            mobile device that is not in conformance with the manufacturer’s
            original specifications, including use of modified versions of the
            operating system (collectively, “Modified Devices”). Use of the
            HOVER App or HOVER Deliverables on Modified Devices will be at the
            Customer’s sole and exclusive risk and liability.
          </Body>
        </>
      );
    },
  },
  {
    title: 'Consent to Information Collection and Use',
    id: 'term-consent-information-collection-use',
    renderContent() {
      return (
        <>
          <Body mb={500}>
            You hereby give HOVER consent to collect and aggregate data related
            to you through the HOVER App or Co-branded App. Collected data may
            include personal information, Image Data, or Property Information.
            You give HOVER consent to use collected data to provide, maintain,
            and improve the Software and Services. Except to perform HOVER’s
            obligations under this Agreement, HOVER will use Image Data only for
            internal business purposes and to maintain or improve the Services
            (including training data and other research and experimental use),
            in all cases only as permitted by applicable law. HOVER will manage
            collected data in accordance with Data Privacy Laws and HOVER’s
            Privacy Policy. A description of the information collected and
            purposes of the collection is available at&nbsp;
            <Link href="https://hover.to/privacy">hover.to/privacy</Link>.
          </Body>
          <Body mb={500}>
            You agree that the images you upload to HOVER will not contain any
            information that itself could identify you or any other individual.
          </Body>
          <Body mb={500}>
            You agree that the images you upload to HOVER will not contain any
            information that itself could identify you or any other individual.
          </Body>
          <Body mb={500}>
            If you process the personal data of Users or other identifiable
            individuals in your use of HOVER’s services, you are responsible for
            providing legally adequate privacy notices and obtaining necessary
            consents for the processing of such data. You represent to us that
            you have provided all necessary privacy notices and obtained all
            necessary consents. You are responsible for processing such data in
            accordance with applicable law, and HOVER relies on those
            representations in processing data.
          </Body>
          <Body mb={500}>
            Users in Europe acting on behalf of European Residents, and unless
            otherwise specified by the Sponsor, are responsible for and must
            ensure a lawful basis for processing personal data, as required by
            Data Privacy Laws, prior to collection and submission through the
            HOVER app. If the resident is a European Resident, User must ensure
            compliance with, and be responsible for, applicable Data Privacy
            Laws. Users’ acceptance of these Terms of Use may be subject to
            additional measures as established between HOVER and an applicable
            Sponsor, such as data processing agreements and transfer tool
            safeguards when appropriate. Users may request these documents at
            all times.
          </Body>
          <Body mb={500}>
            For interactions between a User and a Sponsor through HOVER, these
            Terms of Use shall still be applicable and constitute a legal
            agreement between the User, HOVER, and the applicable Sponsor. For
            example, if you receive a request to use the HOVER App from a
            Sponsor with which you have a relationship, the collection of
            information through the HOVER App as part of that transaction will
            be subject to these Terms of Use.
          </Body>
          <Body>
            Information provided to HOVER by a User and any HOVER Deliverables
            ordered by or provided to a User may be made available to and used
            by HOVER and the Sponsor that paid for the HOVER Deliverable, as
            well as their affiliates and Service Providers, in accordance with
            HOVER’s and the Sponsor’s published privacy policies, such as:
          </Body>
          <UnorderedList mb={500} ml={0}>
            <ListItem>
              processing and managing your purchase and use of HOVER’s products
              and services;
            </ListItem>
            <ListItem>
              verifying your identity and responding to your inquiries or
              requests;
            </ListItem>
            <ListItem>
              creating and delivering personalized promotions;
            </ListItem>
            <ListItem>
              communicating with you by mail, telephone, facsimile, e-mail,
              mobile alerts, SMS text messaging or other reasonable means about:
            </ListItem>
            <UnorderedList ml={0}>
              <ListItem>
                HOVER or the applicable Sponsor and its affiliates;
              </ListItem>
              <ListItem>
                products of HOVER or the applicable Sponsor that may be
                applicable to you;
              </ListItem>
              <ListItem>
                managing permissions for access to HOVER Deliverables already
                provided to you;
              </ListItem>
            </UnorderedList>
            <ListItem>marketing efforts; and</ListItem>
            <ListItem>
              furthering business and support purposes, such as: perform data
              analysis, audits, fraud monitoring and prevention, enhance,
              improve or modify the services, identify usage trends, determine
              the effectiveness of promotional campaigns and operate and expand
              business activities.
            </ListItem>
          </UnorderedList>
          <Body>
            If you are a Sponsored User, you hereby acknowledge and consent to
            the Sponsor’s ability to access, disclose, restrict, monitor, and
            compile information and generate reports from your use of the HOVER
            App and the Software and Services.
          </Body>
        </>
      );
    },
  },
  {
    title: 'Grant of License; Terms of Use',
    id: 'term-grant-license-terms-use',
    renderContent() {
      return (
        <>
          <Body mb={500}>
            <b>(a) Software and Services.</b> HOVER grants to Customer a
            non-exclusive, revocable, sublicensable to end users,
            non-transferable license to those rights necessary to use the
            Software and Services as accessible to Customer for its internal
            business purposes or as otherwise described in accordance with any
            Order Documentation. The foregoing does not entitle Customer to
            physical delivery or possession of any software. The Software and
            Services are licensed, not sold, to Customer. HOVER retains all
            intellectual property rights, title, and interest in and to the
            Software and Services. Other than the limited license granted or as
            described elsewhere in these Terms of Use, Customer has no other
            right, title or interest in the Software and Services. Customer
            shall not, and shall not directly or indirectly permit others to:
            (i) decompile, reverse engineer, disassemble, attempt to derive the
            source code of, or decrypt all or any portion of the Software and
            Services; (ii) access the Software and Services, or use information
            obtained from the Software and Services directly or indirectly, to
            build or promote a product or service competitive to HOVER; (iii)
            make or have made any modification, adaptation, improvement,
            enhancement, translation or derivative work from the Software and
            Services; (iv) remove, alter or obscure any proprietary notice
            (including any notice of copyright or trademark) of HOVER or its
            affiliates, partners, suppliers or the licensors of the Software and
            Services, or otherwise obscure or modify the manner in which the
            Software and Services are displayed; (v) use any robot, spider or
            other automatic program or device to monitor, copy, summarize, or
            otherwise extract information from the HOVER Models or other HOVER
            Deliverables, in whole or in part; (vi) circumvent account access
            controls, or develop, use, or distribute measures that circumvent
            account access and management; or (vii) license, sell, rent, lease,
            transfer, assign, distribute, display, host, outsource, disclose,
            permit timesharing or service bureau use, or otherwise commercially
            exploit or make the Software and Services, programs or materials
            available, to any third-party other than as expressly permitted
            under the terms of this Agreement.
          </Body>
          <Body mb={500}>
            <b>(b) HOVER Deliverables.</b> All HOVER Models and other HOVER
            Deliverables, including the Derived Data incorporated therein, are
            the property of HOVER. HOVER grants to Customer a non-exclusive,
            non-transferable, terminable (as provided herein), limited
            permission (with no right to grant further permission) to use a
            HOVER Deliverable with respect to a Subject Property. Customer shall
            use the HOVER Deliverables for its internal business purposes as
            contemplated at the time Customer enters into this Agreement.
            Customer shall not (i) directly or indirectly sell the HOVER Report
            or any of the Derived Data to third-parties, (ii) use, or enable or
            permit a third-party to use, the HOVER Report or any of the Derived
            Data to build a product or service that directly competes with the
            business of HOVER, (iii) use the HOVER Report or any of the Derived
            Data, directly or indirectly, to improve, teach, or train any of its
            software or algorithms, or (iv) otherwise violate any of the terms
            hereof. Customer shall limit access to the HOVER Report and the
            Derived Data to only those Customer personnel (“Personnel”) who have
            a legitimate need to access that information for a permitted use.
          </Body>
          <Body mb={500}>
            <b>(c) Intellectual Property.</b> The Software and Services are the
            property of HOVER, and subject to the copyright and other
            intellectual property rights of HOVER and its licensors. Use of the
            Software and Services or the HOVER Production Process does not
            create a work-for-hire relationship agreement (as that term is
            defined in 17 U.S.C. § 101). Any technology developed in connection
            with providing the Software and Services, or improvements or
            modifications to the foregoing, shall be owned by HOVER; provided
            however, that HOVER does not have the right to incorporate any of
            Customer’s Confidential Information into the Software and Services
            or any other product or service. Subject to the foregoing, HOVER
            shall have the exclusive right to apply for or register any patents,
            mask work rights, copyrights, and such other proprietary rights
            protections with respect thereto, and you hereby grant all right,
            title, and interest you may have in the foregoing to HOVER. HOVER
            will review allegations of copyright violations in accordance with
            the Digital Millennium Copyright Act (“DMCA”); notices of allegedly
            infringing Image Data or other content (collectively, “Content”)
            shall be sent to&nbsp;
            <Link href="mailto:legal@hover.to">legal@hover.to</Link> or:
            <br />
            HOVER – Copyright Notices <br />
            255 Bush St, 7th Floor <br />
            San Francisco, CA 94104
          </Body>
          <Body>
            <b>(d) No Implied Rights.</b> All rights not expressly granted
            herein are reserved by HOVER. Neither party grants the other party
            any interest or title in or rights to use its trademarks, service
            marks, or other proprietary symbols or designations (“Marks”),
            provided that during the Term, HOVER is hereby granted a limited,
            non-exclusive, non-transferable license to use Sponsor’s Marks
            solely in connection with providing the Software and Services to
            Sponsor. No party will take action to damage the goodwill associated
            with the other’s Marks.
          </Body>
        </>
      );
    },
  },
  {
    title: 'No Unlawful or Prohibited Use',
    id: 'term-unlawful-prohibited-use',
    renderContent() {
      return (
        <>
          <Body mb={500}>
            The license to the Software and Services is conditioned on the
            following:
          </Body>
          <Body mb={500}>
            <b>(a)</b> use will not introduce, transmit, or otherwise upload
            materials or software code to the Software and Services that are
            harmful or unlawful, and use will not have any purpose that is
            unlawful or prohibited by this Agreement;
          </Body>
          <Body mb={500}>
            <b>(b)</b> use will not, in any manner, damage, disable, overburden,
            or impair the Software and Services or interfere with any other
            party’s use and enjoyment of the Software and Services;
          </Body>
          <Body mb={500}>
            <b>(c)</b> there will be no attempt to obtain any materials or
            information not provided for in the HOVER Deliverables; and
          </Body>
          <Body>
            <b>(d)</b> the Software and Services will not be downloaded or used
            in, or transported to, a country or region that is subject to a U.S.
            Government embargo or sanction.
          </Body>
        </>
      );
    },
  },
  {
    title: 'Rights and Responsibilities for Images and Accounts',
    id: 'term-rights-responsibilities',
    renderContent() {
      return (
        <>
          <Body mb={500}>
            <b>(a) </b>Customer represents and warrants that for any data HOVER
            receives, Customer owns or has all necessary rights (including all
            necessary intellectual property rights), permissions, and licenses
            to provide such data (e.g., Image Data or a Blueprint Source), and
            grants to HOVER the license and rights described herein to
            reproduce, display, and modify the data.
          </Body>
          <Body mb={500}>
            <b>(b) </b>Customer hereby grants to HOVER and its affiliates,
            licensees, agents, and sub-licensees, without compensation to it or
            others, a perpetual, irrevocable, non-exclusive, royalty-free,
            transferable, assignable, sub-licensable, worldwide license, to
            copy, modify, create derivative works from, distribute, publicly
            display or otherwise use or exploit the submitted data in any format
            or media (whether now known or hereafter created) for the duration
            of any copyright or other rights in such submitted data. Further, to
            the extent permitted under applicable law, Customer waives and
            releases and covenants not to assert any moral rights that it may
            have in the submitted data. To the extent a HOVER Deliverable is a
            derivative work of submitted data and Customer possesses the
            necessary right, Customer hereby assigns all right, title, and
            interest in the HOVER Deliverables to HOVER; and
          </Body>
          <Body>
            <b>(c) </b>Customer may provide suggestions, comments, or other
            feedback (collectively, <b>&quot;Feedback&quot;</b>) to HOVER with
            respect to its products and services, including the Software and
            Services. Feedback is entirely voluntary. In the event Customer
            furnishes any Feedback to HOVER, HOVER may use Feedback for any
            purpose without obligation of any kind. Customer hereby assigns all
            right, title, and interest in any Feedback to HOVER; to the extent
            Customer cannot assign all rights, Customer hereby grants HOVER an
            irrevocable, non-exclusive, perpetual, royalty-free license to use
            the Feedback in connection with HOVER’s business, including the
            enhancement of Software and Services.
          </Body>
        </>
      );
    },
  },
  {
    title: 'Additional Services',
    id: 'additional-services',
    renderContent() {
      return (
        <>
          <Body mb={500}>
            <b>(a) Product Placement.</b> HOVER may incorporate existing
            agreed-upon images, or modifications and derivatives thereof, of
            Sponsor’s products (“Customer Product Images”) into the Software and
            Services to enable Users to view and render such product images on
            HOVER Models. Sponsor grants HOVER a nonexclusive, irrevocable,
            perpetual, worldwide license to reproduce, modify, create derivative
            works from, publicly perform or publicly display Customer Product
            Images.
          </Body>
          <Body mb={500}>
            <b>(b) HOVER Rendering.</b> A Rendering may be ordered only by a
            Customer or Sponsored User acting on Customer’s behalf. Customer
            represents and warrants that a Rendering is not part of a larger
            work incorporating the output of other rendering services.
          </Body>
          <Body mb={500}>
            <b>(c) Direct Ordering.</b> Customer acknowledges that the Direct
            Ordering feature enables Customer to order materials or services
            from third-party distributors. HOVER DOES NOT WARRANT ANY
            THIRD-PARTY PRODUCTS OR SERVICES. IN ANY EVENT, HOVER&apos;S
            EXCLUSIVE LIABILITY FOR ANY LOSSES RESULTING FROM USE OF THE
            DIRECT-ORDERING FEATURE SHALL NOT EXCEED THE PRICE PAID FOR THE
            HOVER DELIVERABLE USED TO PLACE THE DIRECT ORDER.
          </Body>
          <Body mb={500}>
            <b>(d) Beta Releases.</b> Any beta, pilot, limited release,
            non-production, pre-production or evaluation feature or version of a
            feature or offering provided to Customer (“Beta Releases”) is
            experimental and provided “AS IS” without warranty, support, or
            maintenance of any kind and will not create any obligation for HOVER
            to continue to develop, productize, support, repair, offer for sale,
            or in any other way continue to provide or develop any such feature
            or offering. Customer agrees that its purchase is not contingent on
            the delivery of any future functionality or features, or dependent
            on any oral or written statements made by HOVER regarding future
            functionality or features. HOVER may modify or remove Beta Releases
            at any time.
          </Body>
          <Body mb={500}>
            <b>(e) Estimation Platform.</b> An Estimate Deliverable enables
            quoting and ordering materials for Customers to generate work orders
            of a Subject Property based on a HOVER Model. IN THE EVENT THE HOVER
            APP OR ESTIMATION PLATFORM CAUSES CUSTOMER TO ORDER AN INCORRECT
            AMOUNT OF MATERIALS, CUSTOMER’S SOLE REMEDY WILL BE ACTUAL, DIRECT
            DAMAGES (NO CONSEQUENTIAL DAMAGES) EQUAL TO AN AMOUNT NOT TO EXCEED
            THE PRICE PAID FOR THE HOVER DELIVERABLE USED TO GENERATE THE
            ESTIMATION.
          </Body>
          <Body>
            <b>(f) New Construction Model.</b> The HOVER Production Process
            requires the Blueprint Source comprise (i) multiple elevation views
            of the structure to be reconstructed, including at least a front,
            right, left, and read view; and (ii) a floorplan of the structure to
            be reconstructed, with measurements. When a single Blueprint Source
            file depicts multiple structures, Customer must indicate, through
            applicable upload interfaces, which structure is to be
            reconstructed.
          </Body>
        </>
      );
    },
  },
  {
    title: 'Technical Support.',
    id: 'technical-support',
    renderContent() {
      return (
        <>
          <Body>
            HOVER may provide technical support by telephone from 9:00 am to
            8:00 pm ET during normal business days and from 9:00 am to 5:00 pm
            ET on weekends, and provide maintenance and update services to
            support performance of the Software and Services. Support services
            may also be accessed by email at&nbsp; may also be accessed by email
            at&nbsp;
            <Link href="mailto:support@hover.to">support@hover.to</Link> or
            through the chat feature in the HOVER App or HOVER Web App, with
            emails and chats monitored seven days a week from 9:00 am to 9:00 pm
            ET.
          </Body>
        </>
      );
    },
  },
  {
    title: 'Security and Compliance with Laws.',
    id: 'security-and-compliance-laws',
    renderContent() {
      return (
        <>
          <Body mb={500}>
            <b>(a) </b> HOVER maintains an information-security program designed
            to protect the personal information of Users from unauthorized use
            or disclosure and to comply with Data Privacy Laws.
          </Body>
          <Body>
            <b>(b) </b> Sponsor shall ensure that all information related to
            Users provided hereunder are used, maintained and accessed by
            Sponsor in compliance with applicable Data Privacy Laws, including
            without limitation, the Telemarketing Sales Rule (as amended), the
            Telephone Consumer Protection Act of 1991 and the CAN­SPAM Act of
            2003. If Customer is using the HOVER Connect feature to send
            invitations via text message or email to download and use the HOVER
            App, whether the invitations are initiated via the HOVER App, the
            HOVER Web App, an application program interface, or any other
            bulk-messaging process, Customer shall first obtain the recipient’s
            prior consent, as may be required under applicable law, before
            sending any such HOVER Connect invitation.
          </Body>
        </>
      );
    },
  },
  {
    title: 'Fees',
    id: 'term-fees',
    renderContent() {
      return (
        <>
          <Body mb={500}>
            <b>(a) General.</b> The fees and other charges, if any, for the
            Software and Services and HOVER Deliverables provided hereunder may
            be subject to taxes and duties (such as sales, use, value-added, or
            excise); HOVER may be required to collect or pay now or at any time
            in the future additional amounts with respect to such fees owed, and
            Customer shall pay any such taxes (excluding taxes on HOVER’s net
            income). All pricing is in U.S. Dollars. The Software and Services,
            including but not limited to any subscription fees or volume
            commitments, if applicable, are not subject to proration and are
            non-refundable.
          </Body>
          <Body mb={500}>
            <b>(b) Billing.</b> Payment of the amounts due to HOVER shall be
            made with the payment method and credit terms as selected by
            Customer or as set forth in the Order Documentation. If Customer has
            provided a credit card to HOVER, Customer authorizes HOVER to charge
            the credit card for the amount of any purchase of Software or
            Services or HOVER Deliverables. Any amount due but not paid within
            thirty (30) days may bear a finance charge at the rate of 1.5% per
            month as permitted by law.
          </Body>
          <Body>
            <b>(c) Reliance on charges.</b> Sponsor is responsible for paying
            applicable fees for all HOVER Deliverables ordered by, distributed
            to, or purchased by a User using Sponsor’s account. Sponsor is
            solely responsible for, and HOVER will bear no responsibility for,
            unauthorized access to or use of the Software and Services by any
            person who uses Sponsor credentials. HOVER shall be entitled to rely
            on User’s username, password, and any Sponsor identifier code and/or
            claim number supplied by any User to determine whether such user is
            an authorized User on Sponsor’s account.
          </Body>
        </>
      );
    },
  },
  {
    title: 'Production and Delivery of HOVER Deliverables',
    id: 'term-production-delivery',
    renderContent() {
      return (
        <>
          <Body>
            HOVER does not guarantee the production and delivery of HOVER
            Deliverables. If HOVER is unable to produce a HOVER Deliverable due
            to failure to submit the required Image Data or other required
            information, or for any other reason, you will receive an email
            stating that your order cannot be processed, and no charges will
            accrue. Unless otherwise agreed upon or subject to exceptions in
            this Agreement or Order Documentation, Customer will be charged when
            the HOVER Deliverable is delivered to Customer.
            <br />
            HOVER Deliverables shall be made available through the HOVER App or
            HOVER Web App, email, or by other means as specified in an Order
            Documentation.
          </Body>
        </>
      );
    },
  },
  {
    title: 'Indemnification and Limitation of Liability',
    id: 'term-warranties-limitation',
    renderContent() {
      return (
        <>
          <Body mb={500}>
            <b>(a)</b> Customer shall indemnify, defend and hold harmless HOVER
            and its assignees, subsidiaries, and affiliated companies, and their
            respective officers, directors, employees, shareholders, agents and
            representatives, from and against any and all loss, claim, cost,
            judgment, liability, injury, damage, demand, action, or expense of
            any kind or character brought by a third-party (collectively,
            &quot;third-party Claims&quot;), including court costs and
            reasonable fees of attorneys and other professionals, arising out of
            or in connection with (i) a breach of this Agreement or any of the
            covenants contained herein, (ii) a breach of Data Privacy Laws,
            (iii) the use or possession by Customer of the Software and
            Services, (iv) the use of any Sponsor products and services, (v) the
            use of any Sponsor Marks in connection with a Co-Branded App or a
            HOVER Report, or (vi) an allegation that a HOVER Deliverable based
            on a Blueprint Source infringes, violates or misappropriates any
            patent, copyright, trademark, or other intellectual property right
            of a third-party.
          </Body>
          <Body isBold mb={500}>
            (b) HOVER Indemnification
          </Body>
          <Body mb={500}>
            <b>(i) In General.</b> HOVER shall indemnify, defend and hold
            harmless Sponsor, and its directors, officers, employees and agents,
            from and against any and all third-party Claims, including court
            costs and reasonable fees of attorneys and other professionals,
            arising out of or in connection with (1) HOVER’s willful misconduct,
            or (2) a claim that the Software and Services directly infringe or
            violate any patent, copyright, trademark, or other intellectual
            property right of a third-party. Sponsor must promptly notify HOVER
            of any such claim in writing and give HOVER sole control over the
            defense and settlement of such claim. HOVER may, without the
            knowledge or consent of Sponsor, agree to any resolution of the
            dispute that does not require on the part of Sponsor a payment or an
            admission of wrongdoing. Without limiting the preceding sentence,
            HOVER may, in its sole discretion in the event of a third-party
            infringement claim, (A) seek to obtain through negotiation the right
            of Sponsor to continue using the Software and Services; (B) rework
            the Software and Services so as to make them non-infringing; or (C)
            replace the Software and Services, as long as the reworked or
            replacement Software and Services does not result in a material
            adverse change in the operational characteristics of the Software
            and Services. If none of these alternatives is reasonably available
            in HOVER’s sole discretion, HOVER may terminate this Agreement and
            the license granted herein, and Sponsor shall have no further
            obligation to HOVER.
          </Body>
          <Body mb={500}>
            <b>(ii) Exceptions.</b> HOVER’s indemnity obligation shall not apply
            to infringement relating to (A) Sponsor’s unauthorized modification
            or use of the Software and Services, including HOVER Deliverables;
            (B) Sponsor’s failure to use corrections or enhancements made
            available by HOVER, after notice of the corrections or enhancements
            is provided to Sponsor, and to the extent that such corrections or
            enhancements would make the Software and Services non-infringing;
            (C) use of the Software and Services in excess of the rights granted
            in this Agreement; (D) HOVER’s creation of, or modifications to, the
            Software and Services in compliance with specifications or
            instructions provided by Sponsor; or (E) an allegation that a HOVER
            Deliverable based on content provided by Customer infringes,
            violates or misappropriates any patent, copyright, trademark, or
            other intellectual property right of a third-party.
          </Body>
          <Body mb={500}>
            <b>(c) Disclaimer of Warranties; Limitation of Liability.</b> THE
            SOFTWARE AND SERVICES ARE PROVIDED “AS IS” AND “AS AVAILABLE,” AND
            CUSTOMER AGREES TO USE THEM AT THEIR OWN RISK. HOVER MAKES NO
            GUARANTEES, REPRESENTATIONS OR WARRANTIES OF ANY KIND, EXPRESS OR
            IMPLIED, ARISING BY LAW OR OTHERWISE, INCLUDING BUT NOT LIMITED TO,
            CONTENT, QUALITY, ACCURACY, COMPLETENESS, EFFECTIVENESS,
            RELIABILITY, FITNESS FOR A PARTICULAR PURPOSE, USEFULNESS, USE, OR
            RESULTS TO BE OBTAINED FROM THE SOFTWARE AND SERVICES, EXCEPT THOSE
            EXPRESSLY SET FORTH HEREIN. NO ORAL OR WRITTEN INFORMATION OR ADVICE
            GIVEN BY HOVER OR ITS REPRESENTATIVES WILL CREATE ANY OTHER
            WARRANTIES OR IN ANY WAY INCREASE THE SCOPE OF HOVER’S OBLIGATIONS
            HEREUNDER. HOVER (INCLUDING ITS LICENSEES, ASSIGNEES, SUBSIDIARIES,
            AFFILIATES, AND THEIR RESPECTIVE OFFICERS, DIRECTORS, EMPLOYEES,
            SHAREHOLDERS AND REPRESENTATIVES) SHALL NOT BE LIABLE FOR ANY INJURY
            (INCLUDING WITHOUT LIMITATION PERSONAL INJURY, DISABILITY, OR
            DEATH), DAMAGE (INCLUDING WITHOUT LIMITATION PROPERTY DAMAGE), LOSS,
            CLAIM, LIABILITY, OR EXPENSE, OF ANY KIND, ANY LOSS OF PROFIT,
            REVENUE, CONTRACTS OR SAVINGS, OR ANY INDIRECT, INCIDENTAL, SPECIAL
            OR CONSEQUENTIAL DAMAGES, ARISING OUT OF OR RELATING IN ANY WAY TO
            THIS AGREEMENT OR SPONSOR’S OR ANY USER’S USE OF OR INABILITY TO USE
            THE SOFTWARE AND SERVICES, ANY DEFECT OR ERROR IN ANY SOFTWARE AND
            SERVICES, OR ANY BREACH OF THIS AGREEMENT, WHETHER IN AN ACTION IN
            CONTRACT OR TORT OR BASED ON A WARRANTY. THE AGGREGATE LIABILITY OF
            HOVER (INCLUDING ITS LICENSEES, ASSIGNEES, SUBSIDIARIES, AFFILIATES,
            AND THEIR RESPECTIVE OFFICERS, DIRECTORS, EMPLOYEES, SHAREHOLDERS
            AND REPRESENTATIVES) FOR ALL CLAIMS AND DAMAGES OF EVERY KIND AND
            TYPE, WHETHER IN CONTRACT OR TORT, ARISING OUT OF OR RELATING IN ANY
            WAY TO THIS AGREEMENT, INCLUDING RESULTING FROM THE USE OR
            POSSESSION OF THE SOFTWARE AND SERVICES, SHALL NOT EXCEED, IN THE
            AGGREGATE, THE FEES PAID HEREUNDER BY SPONSOR IN THE TWELVE MONTHS
            IMMEDIATELY PRECEDING THE CLAIM. IN THE EVENT OF AN ERROR IN ANY
            HOVER MODEL OR OTHER HOVER DELIVERABLE, CUSTOMER’S SOLE REMEDY WILL
            BE A REFUND OF THE FEES PAID TO OBTAIN THE HOVER MODEL OR OTHER
            HOVER DELIVERABLE.
          </Body>
          <Body>
            <b>(d) Disclaimer with respect to Contractors.</b> HOVER does not
            endorse, recommend, or make any representations or warranties about
            the service or installation provided by any contractor. Any
            information provided by HOVER relating to contractors is solely for
            informational purposes only. We make no guarantees or
            representations regarding the skills of any contractor, nor do we
            guarantee or warrant the outcome or quality of the job that they may
            perform if you elect to retain their services. Contractors are not
            employees or agents of HOVER, and your choice to use any contractor
            is at your own risk. Your rights are governed by the terms of the
            contract you enter into with the contractor you select, and by
            applicable federal, state, provincial and/or local laws.
            <b>
              HOVER specifically disclaims any liability for any injury or other
              damages arising out of or relating in any way to disputes,
              contracts, or your dealings with contractors. Should you have a
              dispute with any contractor, you hereby agree to release HOVER and
              its agents, employees, or affiliates from any damages or claims of
              every kind of nature, suspected and unsuspected, known and
              unknown, and disclosed or undisclosed, including consequential and
              incidental damages, arising out of or relating in any way to such
              disputes and your dealings with contractors.
            </b>
          </Body>
        </>
      );
    },
  },
  {
    title: 'Term',
    id: 'term-term',
    renderContent() {
      return (
        <>
          <Body mb={500}>
            <b>(a) Duration.</b> Except as otherwise set forth on Order
            Documentation, the initial term of this Agreement shall be one (1)
            year from the date this Agreement is entered into, unless earlier
            terminated (the “Term”). Either party may terminate this Agreement
            (i) immediately if the other party becomes the subject of a petition
            in bankruptcy or any other proceeding relating to insolvency,
            receivership, liquidation or assignment for the benefit of creditors
            or (ii) upon 30 days’ written notice (email being sufficient) to the
            other party if a material breach occurs such as Customer’s failure
            to pay, and if such breach remains uncured at the expiration of such
            period. Customer shall delete all HOVER Deliverables in the event
            Customer’s Agreement is terminated for failure to pay or Customer’s
            other breach of this Agreement. In no event will termination relieve
            Customer of its obligation to pay or entitle Customer to a refund of
            any commitments, subscription fees, fees incurred for Deliverables,
            or other fees owed or paid to HOVER.
          </Body>
          <Body mb={500}>
            <b>(b) Effect of Termination.</b> Upon any termination of this
            Agreement, except as otherwise provided in Section 4(b), the license
            to the Software and Services shall terminate. The sections of this
            Agreement which by their nature are intended to survive shall
            survive any termination or expiration of this Agreement, including
            without limitation the provisions relating to license and use
            restrictions, intellectual property rights, limitations of
            liability, and confidentiality.
          </Body>
          <Body>
            <b>(c) Auto-Renewal.</b> Unless written notice of non-renewal is
            provided by Customer or HOVER at least 30 days prior to the end of
            any Term, (i) the Agreement will automatically renew for a new
            12-month Term, (ii) Customer will be charged a renewal membership
            fee at a rate no greater than its previous membership fee or the
            current membership fee for Customer’s membership tier listed on
            HOVER’s website (whichever is greater), and (iii) Customer will be
            charged fees for HOVER Deliverables ordered by Customer at rates no
            greater than HOVER’s standard rates listed on HOVER’s website.
          </Body>
        </>
      );
    },
  },
  {
    title: 'Confidentiality and Security',
    id: 'term-confidentiality-security',
    renderContent() {
      return (
        <>
          <Body mb={500}>
            <b>(a) Confidentiality.</b> Except as otherwise provided in this
            Agreement, any and all confidential documentation and information
            provided by one party to the other party under this Agreement
            (“Confidential Information”) is confidential and proprietary to the
            disclosing party and shall remain the property of the disclosing
            party. The receiving party agrees that it will not permit the
            duplication, use, or disclosure of any such Confidential Information
            to any person (other than its own employees, agents, or
            representatives who reasonably require such information for the
            performance of its obligations hereunder), unless such duplication,
            use, or disclosure is specifically authorized in writing in advance
            by the disclosing party. Confidential Information of the disclosing
            party may include, without limitation, the terms of Customer’s
            agreement with HOVER, the disclosing party’s past, present, and
            future research, development and business activities, inventions
            (whether patentable or not), software code, database lists,
            technical information, plans, methods, know-how, processes, and
            techniques regarding manufacturing and sale, and the disclosing
            party’s customers, creditors, suppliers, and pricing, whether in
            oral, written, graphic, or electronic form. All Confidential
            Information will remain the exclusive property of the disclosing
            party, and nothing contained in this Agreement shall be construed as
            granting to the receiving party any rights therein, by license or
            otherwise, except the limited right to use such Confidential
            Information solely in the performance of this Agreement. The
            receiving party agrees to reasonably delete, destroy, or return upon
            request of the disclosing party all Confidential Information
            furnished to the receiving party or acquired by the receiving party
            under this Agreement. Confidential Information does not include any
            information that at the time of disclosure: (i) was previously known
            to the receiving party without obligations of confidentiality; (ii)
            is obtained after the date hereof from a third-party which is
            lawfully in possession of such information and not in violation of
            any contractual or legal obligation to a disclosing party with
            respect to such information; (iii) is or becomes part of the public
            domain or otherwise accessible by the public through no fault of
            receiving party or its employees; (iv) is independently
            ascertainable or developed by receiving party or its employees; (v)
            is required to be disclosed by law, provided that receiving party
            promptly after receiving notice of such requirement notifies
            disclosing party to give the disclosing party an opportunity to seek
            any other legal remedies to maintain such Confidential Information
            in confidence; (vi) is approved for release by written authorization
            of disclosing party; or (vii) is otherwise addressed in this
            Agreement. The Derived Data and the Software and Services are the
            Confidential Information of HOVER.
          </Body>
          <Body>
            <b>(b) Equitable Relief.</b> The disclosing party would suffer
            irreparable harm in the event of any disclosure or threatened
            disclosure of Confidential Information in violation of the
            Agreement, and money damages would not be a sufficient remedy for
            any such breach or threatened breach. Without prejudice to the
            rights and remedies otherwise available, the disclosing party will
            be entitled to seek equitable relief by way of injunction, specific
            performance or otherwise, without the requirement of proof of actual
            damages or posting a bond or other security, if the receiving party
            discloses or threatens to disclose Confidential Information in
            violation of this Agreement.
          </Body>
        </>
      );
    },
  },
  {
    title: 'Relationship of Parties',
    id: 'term-relationship-parties',
    renderContent() {
      return (
        <Body>
          Each party will be and act as an independent contractor and not as an
          agent, partner, or joint-venturer with the other party for any purpose
          related to this Agreement or the transactions contemplated hereunder,
          and neither party will by virtue of this Agreement have any right,
          power or authority to act or create any obligation, expressed or
          implied, on behalf of the other party.
        </Body>
      );
    },
  },
  {
    title: 'Assignment',
    id: 'term-assignment',
    renderContent() {
      return (
        <Body>
          The rights and obligations described herein and as may be further
          described in any Order Documentation may not be assigned in whole or
          in part by either party without the prior written consent of the other
          party, which consent will not be unreasonably withheld or delayed,
          except that (a) a Sponsor may assign its rights to any subsidiary or
          affiliate without prior written consent, but with notice to HOVER and
          (b) HOVER may assign without notice in connection with a sale of all,
          or substantially all, of the assets, business or equity of HOVER, by
          merger, consolidation, sale of assets, or otherwise.
        </Body>
      );
    },
  },
  {
    title: 'Disclaimer of Legal Advice',
    id: 'disclaimer-legal-advice',
    renderContent() {
      return (
        <>
          <Body>
            If Customer is using form proposals and contracts provided by HOVER,
            Customer acknowledges the following:
          </Body>
          <UnorderedList mb={500} ml={0}>
            <ListItem>
              HOVER does not review contracts for legal sufficiency; draw legal
              conclusions; provide legal advice, opinions, or recommendations
              about any legal rights, remedies, defenses, options, selection of
              forms, or strategies; or apply the law to the facts of Customer’s
              particular situation.
            </ListItem>
            <ListItem>
              HOVER does not provide legal services, and the Software and
              Services and HOVER’s forms and templates are not a substitute for
              the advice or services of an attorney.
            </ListItem>
            <ListItem>
              Customer’s use of a form document provided by HOVER is neither
              legal advice nor the practice of law, and each form and any
              applicable instructions or guidance are not customized to
              Customer’s particular needs or the law of Customer’s jurisdiction.
            </ListItem>
          </UnorderedList>
        </>
      );
    },
  },
  {
    title: 'Notices',
    id: 'term-notices',
    renderContent() {
      return (
        <Body>
          All notices concerning, required or permitted under this Agreement
          shall be sent to{' '}
          <Link href="mailto:legal@hover.to">legal@hover.to</Link> unless
          otherwise designated in Order Documentation.
        </Body>
      );
    },
  },
  {
    title: 'Data Protection and Addendums',
    id: 'data-protection-addendums',
    renderContent() {
      return (
        <>
          <Body mb={500}>
            These Terms of Use incorporate the&nbsp;
            <Link href="https://21177264.hover-static.pages.dev/pdfs/20221014-HOVER-Data-Processing-Addendum-V2.pdf">
              Data Processing Addendum (&quot;DPA&quot;)
            </Link>
            &nbsp; when applicable Data Privacy Laws apply to your use of
            HOVER’s services to process Customer Data (as defined in the DPA).
            The DPA replaces and supersedes any previously agreed data
            processing addendum between you and HOVER relating to Data Privacy
            Laws.
          </Body>
          <Body>
            HOVER and its affiliates will handle any personal information or
            personal data relating to your Personnel that is provided to HOVER
            in accordance with the handling practices described in HOVER’s
            Privacy Policy (available at&nbsp;
            <Link href="https://hover.to/privacy/">
              https://hover.to/privacy/
            </Link>
            ) or as described in any Order Documentation. You will make HOVER’s
            Privacy Policy available to any Personnel whose personal information
            or personal data you provide to HOVER.
          </Body>
        </>
      );
    },
  },
  {
    title: 'Miscellaneous',
    id: 'term-miscellaneous',
    renderContent() {
      return (
        <>
          <Body mb={500}>
            <b>(a)</b> Neither party will incur any liability to the other on
            account of any loss or damage resulting from any delay or failure to
            perform all or any part of this Agreement if such delay or failure
            is caused, in whole or in part, by events, occurrences, or causes
            beyond its control and without negligence of the parties. Such
            events, occurrences or causes will include, without limitation, acts
            of God, strikes, lockouts, riots, acts of war, terrorism,
            earthquakes, fire, and explosions, but the ability to meet financial
            obligations is expressly excluded.
          </Body>
          <Body mb={500}>
            <b>(b)</b> Any waiver of the provisions of this Agreement or of a
            party’s rights or remedies under this Agreement must be in writing
            to be effective. Failure, neglect, or delay by a party to enforce
            the provisions of this Agreement or its rights or remedies at any
            time will not be deemed a waiver of such party’s rights and will not
            in any way affect the validity of the whole or any part of this
            Agreement or prejudice such party’s right to take subsequent action.
          </Body>
          <Body mb={500}>
            <b>(c)</b> If any term, condition, or provision in this Agreement is
            found to be invalid, unlawful, or unenforceable to any extent, the
            parties shall endeavor in good faith to agree to such amendments
            that will preserve, as far as possible, the intentions expressed in
            this Agreement. If the parties fail to agree on such an amendment,
            such invalid term, condition, or provision will be severed from the
            remaining terms, conditions, and provisions, which will continue to
            be valid and enforceable to the fullest extent permitted by law.
          </Body>
          <Body mb={500}>
            <b>(d)</b> This Agreement contains the entire agreement of the
            parties with respect to the subject matter herein and supersedes all
            previous communications, proposals, representations, understandings,
            and agreements, either oral or written, between the parties with
            respect to said subject matter. No employee, agent, representative
            or affiliate of HOVER or Sponsor has authority to bind HOVER or
            Sponsor, respectively, to any oral representations or warranty
            concerning any HOVER products or services or additional Sponsor
            obligations. Any written representation or warranty not expressly
            contained in this Agreement is unenforceable.
          </Body>
          <Body mb={500}>
            <b>(e)</b> No terms, provisions or conditions of any purchase order,
            acknowledgement or other business form that Sponsor may use in
            connection with the acquisition or licensing of the Software and
            Services will have any effect on the rights, duties or obligations
            of the parties under, or otherwise modify, this Agreement regardless
            of any failure of HOVER to object to such terms, provisions, or
            conditions, except where the same have been mutually agreed-to in
            writing by the parties.
          </Body>
          <Body mb={500}>
            <b>(f)</b> This Agreement may be executed in counterparts, including
            by .pdf format, each of which so executed will be deemed to be an
            original and such counterparts together will constitute one and the
            same instrument.
          </Body>
          <Body mb={500}>
            <b>(g)</b> This Agreement will be interpreted and construed pursuant
            to the laws of the State of California and the United States without
            regard to conflict of law provisions thereof, and without regard to
            the United Nations Convention on the International Sale of Goods.
            Any claims or litigation arising under these Terms will be brought
            in state and federal courts located in San Francisco, California,
            and the parties specifically consent to San Francisco, California,
            as the exclusive venue for any such proceeding.
          </Body>
          <Body mb={500}>
            <b>(h)</b> The parties agree to waive any future challenge to the
            validity and enforceability of these terms and any document
            submitted hereunder on the grounds that it was electronically
            transmitted and/or authorized or accepted.
          </Body>
          <Body mb={500}>
            <b>(i)</b> The language of this Agreement shall be construed in
            accordance with its fair meaning and not for or against any party.
            The parties acknowledge that each party has had the opportunity to
            review this Agreement with counsel, and accordingly any rule of
            construction that would resolve ambiguities in favor of non-drafting
            parties shall not apply to the interpretation of this Agreement.
          </Body>
          <Body>
            <b>(j)</b> All section and paragraph titles and captions contained
            in this Agreement are for convenience only and are not deemed a part
            of the context hereof.
          </Body>
        </>
      );
    },
  },
];

const TERM_OF_USE_PREFIX = `/terms_of_use#term`;

export const TERMS_OF_USE_TABLE_OF_CONTENT = [
  {
    label: 'Certain Definitions',
    to: `${TERM_OF_USE_PREFIX}-certain-definitions`,
  },
  {
    label: 'Requirements of the HOVER App',
    to: `${TERM_OF_USE_PREFIX}-requirements-hover-app`,
  },
  {
    label: 'Consent to Information Collection and Use',
    to: `${TERM_OF_USE_PREFIX}-consent-information-collection-use`,
  },
  {
    label: 'Grant of License; Terms of Use',
    to: `${TERM_OF_USE_PREFIX}-grant-license-terms-use`,
  },
  {
    label: 'No Unlawful or Prohibited Use',
    to: `${TERM_OF_USE_PREFIX}-unlawful-prohibited-use`,
  },
  {
    label: 'Rights and Responsibilities for Images and Accounts',
    to: `${TERM_OF_USE_PREFIX}-rights-responsibilities`,
  },
  {
    label: 'Additional Services',
    to: `${TERM_OF_USE_PREFIX}-additional-services`,
  },
  {
    label: 'Technical Support',
    to: `${TERM_OF_USE_PREFIX}-technical-support`,
  },
  {
    label: 'Security and Compliance with Laws.',
    to: `${TERM_OF_USE_PREFIX}-security-and-compliance-laws`,
  },
  {
    label: 'Fees',
    to: `${TERM_OF_USE_PREFIX}-fees`,
  },
  {
    label: 'Production and Delivery of HOVER Deliverables',
    to: `${TERM_OF_USE_PREFIX}-production-delivery`,
  },
  {
    label: 'Warranties and Limitation of Liability',
    to: `${TERM_OF_USE_PREFIX}-warranties-limitation`,
  },
  {
    label: 'Term',
    to: `${TERM_OF_USE_PREFIX}-term`,
  },
  {
    label: 'Confidentiality and Security',
    to: `${TERM_OF_USE_PREFIX}-term-confidentiality-security`,
  },
  {
    label: 'Relationship of Parties',
    to: `${TERM_OF_USE_PREFIX}-relationship-parties`,
  },
  {
    label: 'Assignment',
    to: `${TERM_OF_USE_PREFIX}-assignment`,
  },
  {
    label: 'Disclaimer of Legal Advice',
    to: `${TERM_OF_USE_PREFIX}-disclaimer-legal-advice`,
  },
  {
    label: 'Notices',
    to: `${TERM_OF_USE_PREFIX}-notices`,
  },
  {
    label: 'Data Protection and Addendums',
    to: `${TERM_OF_USE_PREFIX}-data-protection-addendums`,
  },
  {
    label: 'Miscellaneous',
    to: `${TERM_OF_USE_PREFIX}-miscellaneous`,
  },
];
